import { useEffect, useState } from 'react';
import { useGetOrCreateConnectedAppObjectMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
//Gets or creates object id needed to create and fetch product approval requests
export function useGetOrCreateApprovableObjectId({
  appId
}) {
  const [getOrCreateConnectedAppObject, {
    loading,
    error
  }] = useGetOrCreateConnectedAppObjectMutation({
    variables: {
      appId
    }
  });
  const [objectId, setObjectId] = useState(undefined);
  useEffect(() => {
    getOrCreateConnectedAppObject().then(result => {
      var _result$data;
      setObjectId(result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.result) === null || _result$data === void 0 ? void 0 : _result$data.objectId);
    }).catch(err => {
      console.error(err);
    });
  }, [getOrCreateConnectedAppObject]);
  return {
    approvableObjectId: objectId,
    loading,
    error
  };
}